/**
 * @description use sortAlphabetically
 * @param list
 * @param name
 */
export function sortAlpha(list, name) {
  return list.sort(function (a, b) {
    const nameA = a[name].toUpperCase();
    const nameB = b[name].toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}


/**
 * Ordena un arreglo de forma alfabetica por una propiedad
 *
 */
export function sortAlphabetically<T>(items: T[], prop: keyof T): T[] {
  items.sort((a, b) => {
    const valueA = String(a[prop]).toLowerCase();
    const valueB = String(b[prop]).toLowerCase();
    return valueA.localeCompare(valueB);
  });
  return items;
}
